import {
  ApiDataSourceSpec,
  apiDataSource,
} from '@/io/datasource/ApiDatasource';
import { FileModel, fileSchema } from '@/models/FileModel';
import {
  GeneratePrescriptionData,
  Prescription,
} from '@/models/PrescriptionGenerationModel';
import { cz } from '@/utils/zodUtils.ts';

/**
 * Generate a prescription
 */
export class PrescriptionRepository {
  constructor(private readonly datasource: ApiDataSourceSpec = apiDataSource) {}

  generatePrescription = (
    data: GeneratePrescriptionData,
  ): Promise<Prescription> => {
    return this.datasource.post(
      'prescriptions/create/',
      cz.unsafe<Prescription>(),
      data,
    );
  };

  signPrescription = (data: GeneratePrescriptionData): Promise<FileModel> => {
    return this.datasource.post('prescriptions/sign/', fileSchema, data);
  };
}
